export default class SanitizeUtils {
  static getToken () {
    let token = window.localStorage.getItem('token');
    let lastRefresh = parseInt(window.localStorage.getItem('last-token-refresh'), 10);

    if (typeof token !== 'string' || +new Date() - lastRefresh > 59 * 60 * 1000) {
      return false;
    }

    token = token.replace(/[^a-zA-Z0-9?,._\-=+]/gm, '');
    return token;
  }

  static sanitizeBoolean (value, defaultValue) {
    if (value === 'true' || value === true || value === 1) {
      return true;
    }

    if (value === 'false' || value === false || value === 0) {
      return false;
    }

    return defaultValue;
  }

  static getLocalStorageValue (key, filter, defaultValue = '') {
    let value = window.localStorage.getItem(key);

    if (value === null) {
      return defaultValue;
    }

    if (filter === 'integer') {
      return parseInt(value, 10);
    }

    if (filter === 'float') {
      return parseFloat(value);
    }

    if (filter === 'boolean') {
      return SanitizeUtils.sanitizeBoolean(value, defaultValue);
    }

    return defaultValue;
  }

  static getLocalStorageEnum (key, allowedValues, defaultValue) {
    let value = window.localStorage.getItem(key);

    if (value === null) {
      return defaultValue;
    }

    if (allowedValues.indexOf(value) > -1) {
      return value;
    }

    return defaultValue;
  }
};
